<app-header></app-header>
<section class="content-box">
    <div class="tab-content" id="myTabContent">
        <!--  market Position -->
        <div class="tab-pane fade show active" id="market">
            <div class="deta-tebal-box">
                <div class="card_input_but_box">
                    <button type="button" class="btn but-boxa btn-info" id="expandAll" (click)="chageStatusText(statusText)">{{statusText}}</button>
                    <div class="setin-boxs">
                        <button type="button" class="btn but-boxa btn-success " (click)="openDollerRateChnage()">
                            Doller Rate 
                        </button>
                        <input type="text" placeholder="Search" (keyup)="searchPress($event)"  class="but-boxa search_card_box">
                        <button type="button" class="btn but-boxa btn-info " (click)="openSettledModal()">
                            Weekly Settlement
                        </button>
                        <button type="button" class="btn but-boxa btn-primary " (click)="openBadlaModal()">
                            Create Badla Order
                        </button>
                        <a class="btn but-boxa btn-danger " [routerLink]="['/summery']" >
                            Settlement List 
                        </a>
                        <a class="btn but-boxa btn-danger " [routerLink]="['/endbadlaorder']">
                            Summary  
                        </a>
                    </div>
                </div>
       

                <div class="respo-scroll">
                    <ng-container *ngIf="badlaOrderList.length>0">
                        <table class="default-table-style badla-tebal-box man-baala-colr mb-2"
                            *ngFor="let badlaOrder of badlaOrderList; let i = index; let first = first">

                            <thead>
                                <tr class="basla-box-hed">
                                    <td >
                                        <div class="teble-box-row">
                                            <h5 class="w-100"> Badla Detail : {{badlaOrder['reference']}}
                                                [{{badlaOrder['duty']}}]</h5>

                                      

                                        </div>

                                    </td>
                                    <td colspan="5">
                                        <div class="but-box-teble text-left">
                                            <button type="button" class="btn btn-outline-info btn-sm m-1"
                                                (click)="averageBadla(badlaOrder['type'])">
                                                Average Badla 
                                            </button>
                                            <button type="button" class="btn btn-outline-success btn-sm m-1"
                                                (click)="rollbackBadlaModal(badlaOrder['_id'])">
                                                Rollover
                                            </button>
                                            <button type="button" class="btn btn-outline-primary btn-sm m-1"
                                                (click)="editBadlaModal(badlaOrder['_id'])">
                                                Edit
                                            </button>
                                            <button type="button" class="btn btn-outline-secondary btn-sm m-1"
                                                (click)="endBadlaModal(badlaOrder['_id'])">
                                                End Badla
                                            </button>
                                            <button type="button" class="btn btn-outline-info btn-sm m-1"
                                                (click)="editOpeningModal(badlaOrder['badlRefId'])">
                                                Opening
                                            </button>
                                            <button type="button" class="btn btn-outline-warning btn-sm m-1"
                                                (click)="editDifference(badlaOrder['badlRefId'])">
                                                Difference
                                            </button>
                                            <button type="button" class="btn btn-outline-danger btn-sm m-1"
                                                (click)="deleteBadlaModal(badlaOrder['_id'],badlaOrder['parentBadlaId'])">
                                                <i class="fas fa-trash"></i>
                                            </button>
                                            <button type="button" class="btn btn-outline-success btn-sm m-1"
                                                (click)="partialOrder(badlaOrder['_id'],'buy')">
                                               Buy
                                            </button>
                                            <button type="button" class="btn btn-outline-danger btn-sm m-1"
                                                (click)="partialOrder(badlaOrder['_id'],'sell')">
                                               Sell
                                            </button>
                                        </div>
                                    </td>
                                    <td>{{badlaOrder['createdAt'] | date : 'dd/MM/yyyy hh:mm:ss a'}} 
                                        <!-- <ng-container *ngIf="first">
                                             | Total PL : <span
                                                [ngClass]="overAllResult > 0 ? 'text-success' : 'text-danger'">
                                                {{overAllResult}}</span>
                                        </ng-container> -->
                                    </td>
                                    <td class="text-center">
                                        <button class="but arrow_button" id="{{badlaOrder['_id']}}" type="button"><i class="fas fa-chevron-down"></i></button>
                                    </td>
                                </tr>
                                <tr class="bag-heding">
                                    <th class="text-left col-md-2">Symbol</th>
                                    <th class="text-center col-md-2">Detail</th>
                                    <th class="text-center col-md-1">BID</th>
                                    <th class="text-center col-md-1">ASK</th>
                                    <th class="text-center col-md-2">P/L</th>
                                    <th class="text-center col-md-2">P/L (In Doller)</th>
                                    <th class="text-center col-md-2">Brokerage</th>
                                    <th class="text-center col-md-2">Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                
                                <tr id="{{badlaOrder['_id']}}_mcxHide" class="badla_card_box">
                                    <td class="text-left col-md-2">{{badlaOrder['comexDetail'][0]['original_exchange']}}
                                        - {{badlaOrder['comexDetail'][0]['name']}} {{badlaOrder['comexDetail'][0]['expiry']}}
                                    </td>
                                    <td class="text-center col-md-2">
                                        <span
                                            [ngClass]="badlaOrder['comexType'] == 'buy' ? 'buy-class' : 'sell-class'">{{badlaOrder['comexQty']}}
                                            - {{badlaOrder['comexType'] | titlecase}} -
                                            {{badlaOrder['comexPrice']}}</span>
                                    </td>
                                    <td class="text-center col-md-1">
                                        <span class="{{badlaOrder['comexDetail'][0]['instrument_token']}}_orderBuy">0</span>
                                        <input type="hidden" id="{{badlaOrder['comexDetail'][0]['instrument_token']}}_orderBuyInput">
                                        <input type="hidden" id="{{badlaOrder['comexDetail'][0]['instrument_token']}}_orderLTPInput">
                                    </td>
                                    <td class="text-center col-md-1">
                                        <span class="{{badlaOrder['comexDetail'][0]['instrument_token']}}_orderSell">0</span>
                                        <input type="hidden" id="{{badlaOrder['comexDetail'][0]['instrument_token']}}_orderSellInput">
                                    </td>
                                    <td class="text-center col-md-2" id="{{badlaOrder['_id']}}_comex">0</td>
                                    <td class="text-center col-md-2" id="{{badlaOrder['_id']}}_comex_wdlr">0</td>
                                    <td class="text-center col-md-2" id="{{badlaOrder['_id']}}_comex_bro">0</td>
                                    <td class="text-center col-md-2" id="{{badlaOrder['_id']}}_comex_bro_total">0</td>
                 
                                </tr>
                                <tr id="{{badlaOrder['_id']}}_comexHide" class="badla_card_box ">
                                    <td class="text-left col-md-2">
                                        {{badlaOrder['mcxDetail'][0]['original_exchange']}} -
                                        {{badlaOrder['mcxDetail'][0]['name']}} {{badlaOrder['mcxDetail'][0]['expiry']}}
                                    </td>
                                    <td class="text-center col-md-2">
                                        <span
                                            [ngClass]="badlaOrder['mcxType'] == 'buy' ? 'buy-class' : 'sell-class'">{{badlaOrder['mcxQty']}}
                                            - {{badlaOrder['mcxType'] | titlecase}} - {{badlaOrder['mcxPrice']}}
                                        </span><span
                                            class="{{badlaOrder['comexDetail'][0]['instrument_token']}}_orderRate"></span>
                                    </td>
                                    <td class="text-center col-md-1">
                                        <span class="{{badlaOrder['mcxDetail'][0]['instrument_token']}}_orderBuy">0</span> 
                                        <input type="hidden" id="{{badlaOrder['mcxDetail'][0]['instrument_token']}}_orderBuyInput">
                                        <input type="hidden" id="{{badlaOrder['mcxDetail'][0]['instrument_token']}}_orderLTPInput">
                                    </td>
                                    <td class="text-center col-md-1">
                                        <span class="{{badlaOrder['mcxDetail'][0]['instrument_token']}}_orderSell">0</span>
                                        <input type="hidden" id="{{badlaOrder['mcxDetail'][0]['instrument_token']}}_orderSellInput">
                                    </td>
                                    <td class="text-center col-md-2" id="{{badlaOrder['_id']}}_mcx">0</td>
                                    <td class="text-center col-md-2" id="{{badlaOrder['_id']}}_mcx_wdlr">0</td>                                    
                                    <td class="text-center col-md-2" id="{{badlaOrder['_id']}}_mcx_bro">0</td>
                                    <td class="text-center col-md-2" id="{{badlaOrder['_id']}}_mcx_bro_total">0</td>
                               
                                </tr>
                                <tr id="{{badlaOrder['_id']}}_dgcxHide" class="badla_card_box ">
                                    <td class="text-left col-md-2">
                                        {{badlaOrder['dgcxDetail'][0]['original_exchange']}}
                                        - {{badlaOrder['dgcxDetail'][0]['name']}} {{badlaOrder['dgcxDetail'][0]['expiry']}} 
                                    </td>
                                    <td class="text-center col-md-2">
                                        <span
                                            [ngClass]="badlaOrder['dgcxType'] == 'buy' ? 'buy-class' : 'sell-class'">{{badlaOrder['dgcxQty']}}
                                            - {{badlaOrder['dgcxType'] | titlecase}} -
                                            {{badlaOrder['dgcxPrice']}}</span></td>
                                    <td class="text-center col-md-1">
                                        <span class="{{badlaOrder['dgcxDetail'][0]['instrument_token']}}_orderBuy">0</span>  
                                        <input type="hidden" id="{{badlaOrder['dgcxDetail'][0]['instrument_token']}}_orderBuyInput">
                                        <input type="hidden" id="{{badlaOrder['dgcxDetail'][0]['instrument_token']}}_orderLTPInput">
                                    </td>
                                    <td class="text-center col-md-1">
                                        <span class="{{badlaOrder['dgcxDetail'][0]['instrument_token']}}_orderSell">0</span>
                                        <input type="hidden" id="{{badlaOrder['dgcxDetail'][0]['instrument_token']}}_orderSellInput">
                                    </td>
                                    <td class="text-center col-md-2" id="{{badlaOrder['_id']}}_dgcx">0</td>
                                    <td class="text-center col-md-2" id="{{badlaOrder['_id']}}_dgcx_wdlr">0</td>
                                    <td class="text-center col-md-2" id="{{badlaOrder['_id']}}_dgcx_bro">0</td>
                                    <td class="text-center col-md-2" id="{{badlaOrder['_id']}}_dgcx_bro_total">0</td>
                           
                                </tr >
                                <tr>
                                    <td class="text-center col-md-1"></td>
                                    <td class="text-center col-md-1">
                                        Order Rate Badla : <span
                                        [ngClass]="badlaOrder['rateBadla'] > 0 ? 'buy-class' : 'sell-class'">{{badlaOrder['rateBadla']}}</span>
                                    </td>
                                    <td class="text-center col-md-2">Weekly Settled Badla : <span
                                        [ngClass]="badlaOrder['weeklySettleBadla'] > 0 ? 'buy-class' : 'sell-class'">{{badlaOrder['weeklySettleBadla']}}</span> 
                                    </td>
                                    <td class="text-center col-md-2">Current Badla : <span
                                            id="{{badlaOrder['_id']}}_currentBadla"></span></td>
                                    <td class="text-center col-md-2" id="{{badlaOrder['_id']}}_total"></td>
                                    <td class="text-center col-md-2" id="{{badlaOrder['_id']}}_total_wdlr">0</td>
                                    <td class="text-center col-md-2" id="{{badlaOrder['_id']}}_total_bro"></td>
                                    <td class="text-center col-md-2" id="{{badlaOrder['_id']}}_total_sum">0</td>

                                </tr>
                                <tr *ngIf="badlaOrder['openingAmount']">
                                    <td class="text-center col-md-2"></td>
                                    <td class="text-center col-md-2"></td>
                                    <td class="text-center col-md-2"></td>
                                    <td class="text-center col-md-2">Opening Amount : {{(badlaOrder['plDetail'])?badlaOrder['plDetail']['CalculateBalance']:0}}</td>
                                    <td class="text-center col-md-2" id="{{badlaOrder['_id']}}_withOpeningPL">0</td>
                                    <td class="text-center col-md-2" id="{{badlaOrder['_id']}}_wdlr"></td>
                                    
                                    <td class="text-center col-md-2"></td>
                                    <!-- <td class="text-center col-md-2" id="{{badlaOrder['_id']}}_withOpeningSum">0</td> -->
                                    <td class="text-center col-md-2"></td>
                                    
                                </tr>
                            </tbody>
                        </table>

                    </ng-container>
                    <ng-container *ngIf="badlaOrderList.length==0">
                        <table class="default-table-style badla-tebal-box">
                            <thead>
                                <tr>
                                    <th class="text-center">No data found</th>
                                </tr>
                            </thead>
                        </table>
                    </ng-container>

                </div>


            </div>
        </div>
        <!-- badle settig -->
        <div class="tab-pane fade" id="badle">
            1
        </div>
        <!--  settig Report -->
        <div class="tab-pane fade" id="settig">
            2
        </div>
        <!-- porfile Summary -->
        <div class="tab-pane fade" id="porfile">
            3
        </div>



    </div>

</section>

<app-footer></app-footer>

<!-- Modal -->
<div class="modal fade" bsModal #orderModal="bs-modal" [config]="{}" id="exampleModalCenter" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg " role="document">
        <div class="modal-content ">
            <div class="modal-header">
                <h6 class="modal-title" id="exampleModalLongTitle"> <span *ngIf="!filter.id && endOrder==false">Add
                        badla order</span> <span *ngIf="filter.id && endOrder==false">Update badla order</span> <span
                        *ngIf="endOrder==true">End badla order</span></h6>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal()">
                    <span aria-hidden="true">&times;</span>
                </button>

            </div>
            <div class="modal-body p-0 m-2">
                <form #addBadlaOrder="ngForm" (ngSubmit)="(addBadlaOrder.form.valid  && createBadlaOrder())">
                    <div class="form-group row">
                        <div class=" col-lg-4 col-sm-6 col-6 input-box-grup">
                            <label for="inputPassword" class=" col-form-label">Reference Name</label>
                            <input type="text" class="form-control" placeholder="Reference Name"
                                [(ngModel)]="filter.reference" name="referenceName" #referenceName="ngModel" required
                                pattern="^[A-Za-z0-9._ -]*$" maxlength="50" [disabled]="endOrder==true">
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="referenceName.errors?.required" class="invalid-error">
                                    Enter Reference.
                                </div>
                                <div *ngIf="referenceName.errors?.pattern" class="invalid-error">
                                    Enter Valid Reference.
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-sm-6 col-6 input-box-grup" *ngIf="!filter.id && endOrder==false">
                            <label for="inputPassword" class="col-form-label ">Select Badla Type</label>
                            <select class="form-control" name="badlaType" (change)="badlaTypeChnage($event.target.value)" [(ngModel)]="selectedBadlaType">
                                <option [ngValue]="null">All</option>
                                <option *ngFor="let category of instrumentCategory; let i = index;" value="{{category.name}}">{{category.name}}</option>                          
                            </select>
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="badlaType.errors?.required" class="invalid-error">
                                    Please Select Badla Type.
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-2 col-sm-3 col-6 input-box-grup main-chek " >
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault"
                                    [(ngModel)]="isBrokrageCheck" name="brokrageCheckBox" #brokrageCheckBox="ngModel"
                                    (change)="checkBrokrage(isBrokrageCheck?true:false)" *ngIf="endOrder == false">
                                <label class="form-check-label" for="flexCheckDefault">
                                    Add Brokerage
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-lg-4 col-sm-6 col-6 input-box-grup">
                            <label for="inputPassword" class="col-form-label ">Badla Instrument</label>
                            <select class="form-control" [(ngModel)]="filter.type" name="badlaType" #badlaType="ngModel"
                                required [disabled]="endOrder==true" (change)="badlaScriptChnage($event.target.value)">
                                <option [ngValue]="null" *ngIf="!filter.id && endOrder==false">Select Badla</option>
                                <option *ngFor="let title of badlaInstrument" [value]="title._id">
                                    {{title.settingName}}
                                </option>
                            </select>
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="badlaType.errors?.required" class="invalid-error">
                                    Please Select Badla Type.
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 col-sm-6 col-6 input-box-grup">
                            <label for="inputPassword" class="col-sm-2 col-form-label">Duty</label>
                            <input type="text" class="form-control" placeholder="Duty" [(ngModel)]="filter.duty"
                                name="dutyName" #dutyName="ngModel" required pattern="^[0-9._-]*$" maxlength="10"
                                [disabled]="endOrder==true">
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="dutyName.errors?.required" class="invalid-error">
                                    Enter Duty.
                                </div>
                                <div *ngIf="dutyName.errors?.pattern" class="invalid-error">
                                    Enter Valid Duty.
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-sm-6 col-6 input-box-grup"  *ngIf="!filter.id && endOrder==false">
                            <label for="inputPassword" >Opening Amount(Optional)</label>
                            <input type="text" class="form-control" placeholder="Opening Amount" [(ngModel)]="filter.openingAmount"
                                name="openingAmount" #openingAmount="ngModel" pattern="^[0-9._-]*$" maxlength="10"
                                [disabled]="endOrder==true">
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="openingAmount.errors?.pattern" class="invalid-error">
                                    Enter Valid Opening Amount.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="inputPassword" class="col-form-label">COMEX Instrument</label>
                            <select class="form-control" [(ngModel)]="filter.comexbadlaInst" name="comexInstName"
                                #comexInstName="ngModel" (change)="chnageInsrument($event.target.value,'comexRateId')" required [disabled]="endOrder==true">
                                <option [ngValue]="null">Select Instrument</option>
                                <option *ngFor="let badla of comexBadlaInstrument" [value]="badla.instrument_token">
                                    {{badla.exchange}} - {{badla.name}} - {{badla.expiry}}
                                </option>
                            </select>
                            <div id="comexRateId"></div>
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="comexInstName.errors?.required" class="invalid-error">
                                    Please Select COMEX Instrument.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Type" class="col-form-label">Type</label>
                            <select class="form-control" [(ngModel)]="filter.comexType" name="comexTypeName"
                                #comexTypeName="ngModel" required (change)="comexTypeChnage()"
                                [disabled]="endOrder==true">
                                <option [ngValue]="null">Type</option>
                                <option value="buy">Buy</option>
                                <option value="sell">Sell</option>
                            </select>
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="comexTypeName.errors?.required" class="invalid-error">
                                    Please Select Type.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Qty" class="col-form-label">Qty</label>
                            <input type="text" class="form-control" placeholder="Qty" [(ngModel)]="filter.comexQty"
                                name="comexQtyeName" #comexQtyeName="ngModel" required pattern="^[0-9._-]*$" (keyup)="updateDgexcQty()"
                                maxlength="5" [disabled]="endOrder==true">
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="comexQtyeName.errors?.required" class="invalid-error">
                                    Enter Qty.
                                </div>
                                <div *ngIf="comexQtyeName.errors?.pattern" class="invalid-error">
                                    Enter Valid Qty.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Price" class="col-form-label">Price</label>
                            <input type="text" class="form-control" [(ngModel)]="filter.comexPrice" placeholder="Price"
                                name="comexPriceName" #comexPriceName="ngModel" required pattern="^[0-9.]*$"
                                maxlength="10">
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="comexPriceName.errors?.required" class="invalid-error">
                                    Enter Price.
                                </div>
                                <div *ngIf="comexPriceName.errors?.pattern" class="invalid-error">
                                    Enter Valid Price.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}" *ngIf="isBrokrageCheck">
                            <label for="Type" class="col-form-label">Type</label>
                            <select class="form-control" [(ngModel)]="filter.comexBroType" name="comexBrokrageType"
                                #comexBrokrageType="ngModel">
                                <option [ngValue]="null">Brokrage Type</option>
                                <option value="lot">Lotwise</option>
                                <!-- <option value="sell">Percentage</option> -->
                            </select>
                            <!-- <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="comexBrokrageType.errors?.required" class="invalid-error">
                                    Please Select Type.
                                </div>
                            </div> -->
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}" *ngIf="isBrokrageCheck">
                            <label for="Brokerage Amount" class="col-form-label">Brokerage Amount</label>
                            <input type="text" class="form-control" placeholder="Brokerage Amount"
                                [(ngModel)]="filter.comexBroAmount" name="comexBrokrageAmount"
                                #comexBrokrageAmount="ngModel" pattern="^[0-9._-]*$" maxlength="5">
                            <div *ngIf="addBadlaOrder.submitted">
                                <!-- <div *ngIf="comexBrokrageAmount.errors?.required" class="invalid-error">
                                    Enter Amount.
                                </div> -->
                                <div *ngIf="comexBrokrageAmount.errors?.pattern" class="invalid-error">
                                    Enter Valid Amount.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="MCX Instrument" class="col-form-label">MCX Instrument</label>
                            <select class="form-control" [(ngModel)]="filter.mcxbadlaInst" name="mcxInstName" (change)="chnageInsrument($event.target.value,'mcxRateId')" 
                                #mcxInstName="ngModel" required [disabled]="endOrder==true">
                                <option [ngValue]="null">Select Instrument</option>
                                <option *ngFor="let badla of mcxBadlaInstrument" [value]="badla.instrument_token">
                                    {{badla.exchange}} - {{badla.name}} - {{badla.expiry}}
                                </option>
                            </select>
                            <div id="mcxRateId"></div>
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="mcxInstName.errors?.required" class="invalid-error">
                                    Please Select MCX Instrument.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Type" class="col-form-label">Type</label>
                            <select class="form-control" [(ngModel)]="filter.mcxType" name="mcxTypeName"
                                #mcxTypeName="ngModel" required disabled='true'>
                                <option [ngValue]="null">Type</option>
                                <option value="buy">Buy</option>
                                <option value="sell">Sell</option>
                            </select>
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="mcxTypeName.errors?.required" class="invalid-error">
                                    Please Select Type.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Qty" class="col-form-label">Qty</label>
                            <input type="text" class="form-control" [(ngModel)]="filter.mcxQty" placeholder="Qty"
                                name="mcxQtyeName" #mcxQtyeName="ngModel" required pattern="^[0-9.]*$"
                                [disabled]="endOrder==true">
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="mcxQtyeName.errors?.required" class="invalid-error">
                                    Enter Qty.
                                </div>
                                <div *ngIf="mcxQtyeName.errors?.pattern" class="invalid-error">
                                    Enter Valid Qty.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Price" class="col-form-label">Price</label>
                            <input type="text" class="form-control" [(ngModel)]="filter.mcxPrice" placeholder="Price"
                                name="mcxPriceName" #mcxPriceName="ngModel" pattern="^[0-9_.-]*$" required>
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="mcxPriceName.errors?.required" class="invalid-error">
                                    Enter Price.
                                </div>
                                <div *ngIf="mcxPriceName.errors?.pattern" class="invalid-error">
                                    Enter Valid Qty.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}" *ngIf="isBrokrageCheck">
                            <label for="Type" class="col-form-label">Type</label>
                            <select class="form-control" [(ngModel)]="filter.mcxBroType" name="mcxBrokrageType"
                                #mcxBrokrageType="ngModel">
                                <option [ngValue]="null">Brokrage Type</option>
                                <option value="lot">Lotwise</option>
                                <option value="per">Turnoverwise % | Lakh</option>
                            </select>
                            <!-- <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="mcxBrokrageType.errors?.required" class="invalid-error">
                                    Please Select Type.
                                </div>
                            </div> -->
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}" *ngIf="isBrokrageCheck">
                            <label for="Brokerage Amount" class="col-form-label">Brokerage Amount</label>
                            <input type="text" class="form-control" placeholder="Brokerage Amount"
                                [(ngModel)]="filter.mcxBroAmount" name="mcxBrokrageAmount" #mcxBrokrageAmount="ngModel"
                                 pattern="^[0-9._-]*$" maxlength="5">
                            <div *ngIf="addBadlaOrder.submitted">
                                <!-- <div *ngIf="mcxBrokrageAmount.errors?.required" class="invalid-error">
                                    Enter Amount.
                                </div> -->
                                <div *ngIf="mcxBrokrageAmount.errors?.pattern" class="invalid-error">
                                    Enter Valid Amount.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="inputPassword" class=" col-form-label">DGCX Instrument</label>
                            <select class="form-control" [(ngModel)]="filter.dgcxbadlaInst" name="dgcxInstName" (change)="chnageInsrument($event.target.value,'dgcxRateId')"
                                #dgcxInstName="ngModel" required [disabled]="endOrder==true">
                                <option [ngValue]="null">Select Instrument</option>
                                <option *ngFor="let badla of dgcxBadlaInstrument" [value]="badla.instrument_token">
                                    {{badla.exchange}} - {{badla.name}} - {{badla.expiry}}
                                </option>
                            </select>
                            <div id="dgcxRateId"></div>
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="dgcxInstName.errors?.required" class="invalid-error">
                                    Please Select DGCX Instrument.
                                </div>
                            </div>
                        </div>
                     
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Type" class=" col-form-label">Type</label>
                            <select class="form-control" [(ngModel)]="filter.dgcxType" name="dgcxTypeName"
                                #dgcxTypeName="ngModel" required disabled='true'>
                                <option [ngValue]="null">Type</option>
                                <option value="buy">Buy</option>
                                <option value="sell">Sell</option>
                            </select>
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="dgcxTypeName.errors?.required" class="invalid-error">
                                    Please Select Type.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Qty" class=" col-form-label">Qty <span *ngIf="finalDgRecco == true"> Our Recoomand is :  {{finalDgQty}} Qty</span></label>
                            <input type="text" class="form-control" placeholder="Qty" [(ngModel)]="filter.dgcxQty"
                                name="dgcxQtyeName" #dgcxQtyeName="ngModel" required pattern="^[0-9.]*$" 
                                [disabled]="endOrder==true">
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="dgcxQtyeName.errors?.required" class="invalid-error">
                                    Enter Qty.
                                </div>
                                <div *ngIf="dgcxQtyeName.errors?.pattern" class="invalid-error">
                                    Enter Valid Qty.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Price" class=" col-form-label">Price</label>
                            <input type="text" class="form-control" [(ngModel)]="filter.dgcxPrice" placeholder="Price"
                                name="dgcxPriceName" #dgcxPriceName="ngModel" required pattern="^[0-9_.-]*$">
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="dgcxPriceName.errors?.required" class="invalid-error">
                                    Enter Price.
                                </div>
                                <div *ngIf="dgcxPriceName.errors?.pattern" class="invalid-error">
                                    Enter Valid Price.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}" *ngIf="isBrokrageCheck">
                            <label for="inputPassword" class=" col-form-label">Type</label>
                            <select class="form-control" [(ngModel)]="filter.dgcxBroType" name="dgcxBrokrageType"
                                #dgcxBrokrageType="ngModel">
                                <option [ngValue]="null">Brokrage Type</option>
                                <option value="lot">Lotwise</option>
                                <!-- <option value="sell">Percentage</option> -->
                            </select>
                            <!-- <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="dgcxBrokrageType.errors?.required" class="invalid-error">
                                    Please Select Type.
                                </div>
                            </div> -->
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}" *ngIf="isBrokrageCheck">
                            <label for="Brokerage Amount" class=" col-form-label">Brokerage Amount</label>
                            <input type="text" class="form-control" placeholder="Brokerage Amount"
                                [(ngModel)]="filter.dgcxBroAmount" name="dgcxBrokrageAmount"
                                #dgcxBrokrageAmount="ngModel" pattern="^[0-9._-]*$" maxlength="5">
                            <div *ngIf="addBadlaOrder.submitted"> 
                                <!-- <div *ngIf="dgcxBrokrageAmount.errors?.required" class="invalid-error">
                                    Enter Amount.
                                </div> -->
                                <div *ngIf="dgcxBrokrageAmount.errors?.pattern" class="invalid-error">
                                    Enter Valid Amount.
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="form-group row" *ngIf="endOrder==true">
                        <!-- <div class="col-lg-3 col-sm-6 col-6">
                            <input name="options" ng-control="options" type="radio" [value]="1" [(ngModel)]="filter.endandopen"> End Badla<br/>
                        </div>
                        <div class="col-lg-3 col-sm-6 col-6">
                            <input name="options" ng-control="options" type="radio" [value]="2" [(ngModel)]="filter.endandopen"> End Badla & Open<br/>
                        </div> -->
                        <div class="col-lg-3 col-sm-6 col-6 input-box-grup">
                            <label for="Brokerage Amount" class=" col-form-label">Select End Badla Option</label>
                            <select class="form-control" [(ngModel)]="filter.endandopen" name="endBadlaType"
                                    #endBadlaType="ngModel" required  (change)="settlementTypeChnage($event.target.value)">
                                    <option [ngValue]="null">Type</option>
                                    <option value="1">End Badla</option>
                                    <!-- <option value="2">End Badla With Brokerage</option> -->
                                    <option value="2">Weekly Settlement</option>
                                    <option value="3">Weekly Settlement With Clearing Rate</option>
                            </select>
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="endBadlaType.errors?.required" class="invalid-error">
                                    Enter Badla Type.
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-2 col-sm-3 col-6 input-box-grup main-chek " *ngIf="endOrder==true && settlementType == '1'">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault"
                                    [(ngModel)]="isEndClosingRate" name="closdingCheckBox" #closdingCheckBox="ngModel"
                                    (change)="checkEndClosing(isEndClosingRate?true:false)">
                                <label class="form-check-label" for="flexCheckDefault">
                                    Add Closing Rate 
                                </label>
                            </div>
                        </div>
                        <div class="col-lg-3 col-sm-6 col-6 input-box-grup" *ngIf="endOrder==true && (settlementType == '3') ">
                            <label for="Brokerage Amount" class=" col-form-label">Doller Closing Rate</label>
                            <input type="text" class="form-control" [(ngModel)]="closingRate" placeholder="Doller Closing"
                            name="closingRateAmt" #closingRateAmt="ngModel" required pattern="^[0-9_.-]*$">
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="closingRateAmt.errors?.required" class="invalid-error">
                                    Enter Doller Closing.
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 col-sm-6 col-6 input-box-grup" *ngIf="endOrder==true && settlementType == '1' && isEndClosingRate== true ">
                            <label for="Brokerage Amount" class=" col-form-label">Doller Closing Rate</label>
                            <input type="text" class="form-control" [(ngModel)]="closingRate" placeholder="Doller Closing"
                            name="closingRateAmt" #closingRateAmt="ngModel" required pattern="^[0-9_.-]*$">
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="closingRateAmt.errors?.required" class="invalid-error">
                                    Enter Doller Closing.
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-2 col-sm-3 col-6 input-box-grup main-chek " *ngIf="endOrder==true && settlementType == '1'">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault"
                                    [(ngModel)]="isBrokrageCheckEnd" name="brokrageCheckBox" #brokrageCheckBox="ngModel"
                                    (change)="checkBrokrageEnd(isBrokrageCheckEnd?true:false)">
                                <label class="form-check-label" for="flexCheckDefault">
                                    Add Brokerage
                                </label>
                            </div>
                        </div>

                    </div>

                    <div class="row mt-2">
                        <div class="col-6 m-0 ">
                            <button type="button" class="btn btn-danger w-100" data-dismiss="modal"
                                (click)="closeModal()">Close</button>
                        </div>

                        <div class="col-6 m-0 " *ngIf="!filter.id && endOrder==false">
                            <button type="submit" class="btn btn-success w-100">Submit</button>
                        </div>
                        <div class="col-6 m-0" *ngIf="filter.id && endOrder==false">
                            <button type="submit" class="btn btn-success w-100">Update</button>
                        </div>
                        <div class="col-6 m-0" *ngIf="endOrder==true">
                            <button type="submit" class="btn btn-success w-100">Submit</button>
                        </div>
                    </div>
                    <!--  -->
                </form>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" bsModal #rolloverModal="bs-modal" [config]="{}" id="exampleModalCenter" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg " role="document">
        <div class="modal-content ">
            <div class="modal-header">
                <h6 class="modal-title" id="exampleModalLongTitle"><span>Rollover</span></h6>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeRolloverBadlaOrder()">
                    <span aria-hidden="true">&times;</span>
                </button>

            </div>
            <div class="modal-body p-0 m-2">
                <form #rollbackBadlaOrder="ngForm" (ngSubmit)="(rollbackBadlaOrder.form.valid  && roolbackBadlaOrder())">
                    <div class="form-group row">
                        <div class=" col-lg-4 col-sm-6 col-6 input-box-grup">
                            <label for="inputPassword" class=" col-form-label">Reference Name</label>
                            <input type="text" class="form-control" placeholder="Reference Name"
                                [(ngModel)]="filter.reference" name="referenceName" #referenceName="ngModel"  disabled required
                                pattern="^[A-Za-z0-9._ -]*$" maxlength="50" [disabled]="endOrder==true">
                            <div *ngIf="rollbackBadlaOrder.submitted">
                                <div *ngIf="referenceName.errors?.required" class="invalid-error">
                                    Enter Reference.
                                </div>
                                <div *ngIf="referenceName.errors?.pattern" class="invalid-error">
                                    Enter Valid Reference.
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-2 col-sm-3 col-6 input-box-grup main-chek ">
                            <div class="form-check" *ngIf="endOrder == false">
                                <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault"
                                    [(ngModel)]="isBrokrageCheck" name="brokrageCheckBox" #brokrageCheckBox="ngModel"
                                    (change)="checkBrokrage(isBrokrageCheck?true:false)">
                                <label class="form-check-label" for="flexCheckDefault">
                                    Add Brokerage
                                </label>
                            </div>

                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-lg-4 col-sm-6 col-6 input-box-grup">
                            <label for="inputPassword" class="col-form-label ">Badla Instrument</label>
                            <select class="form-control" [(ngModel)]="filter.type" name="badlaType" #badlaType="ngModel"
                                required disabled (change)="badlaScriptChnage($event.target.value)">
                                <option [ngValue]="null">Select Badla</option>
                                <option *ngFor="let title of badlaInstrument" [value]="title._id">
                                    {{title.settingName}}
                                </option>
                            </select>
                            <div *ngIf="rollbackBadlaOrder.submitted">
                                <div *ngIf="badlaType.errors?.required" class="invalid-error">
                                    Please Select Badla Type.
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 col-sm-6 col-6 input-box-grup">
                            <label for="inputPassword" class="col-sm-2 col-form-label">Duty</label>
                            <input type="text" class="form-control" placeholder="Duty" [(ngModel)]="filter.duty" disabled
                                name="dutyName" #dutyName="ngModel" required pattern="^[0-9._-]*$" maxlength="10"
                                [disabled]="endOrder==true">
                            <div *ngIf="rollbackBadlaOrder.submitted">
                                <div *ngIf="dutyName.errors?.required" class="invalid-error">
                                    Enter Duty.
                                </div>
                                <div *ngIf="dutyName.errors?.pattern" class="invalid-error">
                                    Enter Valid Duty.
                                </div>
                            </div>
                        </div>
                        <!-- <div class="col-lg-4 col-sm-6 col-6 input-box-grup">
                            <label for="inputPassword" >Opening Amount(Optional)</label>
                            <input type="text" class="form-control" placeholder="Opening Amount" [(ngModel)]="filter.openingAmount"
                                name="openingAmount" #openingAmount="ngModel" pattern="^[0-9._-]*$" maxlength="10"
                                [disabled]="endOrder==true">
                            <div *ngIf="rollbackBadlaOrder.submitted">
                                <div *ngIf="openingAmount.errors?.pattern" class="invalid-error">
                                    Enter Valid Opening Amount.
                                </div>
                            </div>
                        </div> -->
                    </div>
                    <div class="form-group row">
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="inputPassword" class="col-form-label">COMEX Instrument</label>
                            <input class="form-check-input chak-obox" type="checkbox" [(ngModel)]="isComexROCheck" name="comexCheckbox" (change)="checkRollover('comex',isComexROCheck?true:false)">

                            <select class="form-control" [(ngModel)]="filter.comexbadlaInst" name="comexInstName"
                                #comexInstName="ngModel" (change)="chnageInsrument($event.target.value,'comexRateId')" required disabled>
                                <option [ngValue]="null">Select Instrument</option>
                                <option *ngFor="let badla of comexBadlaInstrument" [value]="badla.instrument_token">
                                    {{badla.exchange}} - {{badla.name}} - {{badla.expiry}}
                                </option>
                            </select>
                            <div id="comexRateId"></div>
                            <div *ngIf="rollbackBadlaOrder.submitted">
                                <div *ngIf="comexInstName.errors?.required" class="invalid-error">
                                    Please Select COMEX Instrument.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Type" class="col-form-label">Type</label>
                            <select class="form-control" [(ngModel)]="filter.comexType" name="comexTypeName"
                                #comexTypeName="ngModel" required (change)="comexTypeChnage()"
                                disabled>
                                <option [ngValue]="null">Type</option>
                                <option value="buy">Buy</option>
                                <option value="sell">Sell</option>
                            </select>
                            <div *ngIf="rollbackBadlaOrder.submitted">
                                <div *ngIf="comexTypeName.errors?.required" class="invalid-error">
                                    Please Select Type.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Qty" class="col-form-label">Qty</label>
                            <input type="text" class="form-control" placeholder="Qty" [(ngModel)]="filter.comexQty"
                                name="comexQtyeName" #comexQtyeName="ngModel" required pattern="^[0-9._-]*$"
                                maxlength="5" disabled>
                            <div *ngIf="rollbackBadlaOrder.submitted">
                                <div *ngIf="comexQtyeName.errors?.required" class="invalid-error">
                                    Enter Qty.
                                </div>
                                <div *ngIf="comexQtyeName.errors?.pattern" class="invalid-error">
                                    Enter Valid Qty.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Price" class="col-form-label">Price</label>
                            <input type="text" class="form-control" [(ngModel)]="filter.comexPrice" placeholder="Price"
                                name="comexPriceName" #comexPriceName="ngModel" required pattern="^[0-9.]*$"
                                maxlength="10">
                            <div *ngIf="rollbackBadlaOrder.submitted">
                                <div *ngIf="comexPriceName.errors?.required" class="invalid-error">
                                    Enter Price.
                                </div>
                                <div *ngIf="comexPriceName.errors?.pattern" class="invalid-error">
                                    Enter Valid Price.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}" *ngIf="isBrokrageCheck">
                            <label for="Type" class="col-form-label">Type</label>
                            <select class="form-control" [(ngModel)]="filter.comexBroType" name="comexBrokrageType"
                                #comexBrokrageType="ngModel" [disabled]="endOrder==true">
                                <option [ngValue]="null">Brokrage Type</option>
                                <option value="lot">Lotwise</option>
                                <!-- <option value="sell">Percentage</option> -->
                            </select>
                            <!-- <div *ngIf="rollbackBadlaOrder.submitted">
                                <div *ngIf="comexBrokrageType.errors?.required" class="invalid-error">
                                    Please Select Type.
                                </div>
                            </div> -->
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}" *ngIf="isBrokrageCheck">
                            <label for="Brokerage Amount" class="col-form-label">Brokerage Amount</label>
                            <input type="text" class="form-control" placeholder="Brokerage Amount"
                                [(ngModel)]="filter.comexBroAmount" name="comexBrokrageAmount"
                                #comexBrokrageAmount="ngModel" pattern="^[0-9._-]*$" maxlength="5"
                                [disabled]="endOrder==true">
                            <div *ngIf="rollbackBadlaOrder.submitted">
                                <!-- <div *ngIf="comexBrokrageAmount.errors?.required" class="invalid-error">
                                    Enter Amount.
                                </div> -->
                                <div *ngIf="comexBrokrageAmount.errors?.pattern" class="invalid-error">
                                    Enter Valid Amount.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="MCX Instrument" class="col-form-label">MCX Instrument</label>
                            <input class="form-check-input chak-obox" type="checkbox" [(ngModel)]="isMcxROCheck" name="mcxCheckbox" (change)="checkRollover('mcx',isMcxROCheck?true:false)">

                            <select class="form-control" [(ngModel)]="filter.mcxbadlaInst" name="mcxInstName" (change)="chnageInsrument($event.target.value,'mcxRateId')" disabled
                                #mcxInstName="ngModel" required>
                                <option [ngValue]="null">Select Instrument</option>
                                <option *ngFor="let badla of mcxBadlaInstrument" [value]="badla.instrument_token">
                                    {{badla.exchange}} - {{badla.name}} - {{badla.expiry}}
                                </option>
                            </select>
                            <div id="mcxRateId"></div>
                            <div *ngIf="rollbackBadlaOrder.submitted">
                                <div *ngIf="mcxInstName.errors?.required" class="invalid-error">
                                    Please Select MCX Instrument.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Type" class="col-form-label">Type</label>
                            <select class="form-control" [(ngModel)]="filter.mcxType" name="mcxTypeName"
                                #mcxTypeName="ngModel" required disabled='true'>
                                <option [ngValue]="null">Type</option>
                                <option value="buy">Buy</option>
                                <option value="sell">Sell</option>
                            </select>
                            <div *ngIf="rollbackBadlaOrder.submitted">
                                <div *ngIf="mcxTypeName.errors?.required" class="invalid-error">
                                    Please Select Type.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Qty" class="col-form-label">Qty</label>
                            <input type="text" class="form-control" [(ngModel)]="filter.mcxQty" placeholder="Qty"
                                name="mcxQtyeName" #mcxQtyeName="ngModel" required pattern="^[0-9.]*$"
                                disabled>
                            <div *ngIf="rollbackBadlaOrder.submitted">
                                <div *ngIf="mcxQtyeName.errors?.required" class="invalid-error">
                                    Enter Qty.
                                </div>
                                <div *ngIf="mcxQtyeName.errors?.pattern" class="invalid-error">
                                    Enter Valid Qty.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Price" class="col-form-label">Price</label>
                            <input type="text" class="form-control" [(ngModel)]="filter.mcxPrice" placeholder="Price"
                                name="mcxPriceName" #mcxPriceName="ngModel" pattern="^[0-9_.-]*$" required>
                            <div *ngIf="rollbackBadlaOrder.submitted">
                                <div *ngIf="mcxPriceName.errors?.required" class="invalid-error">
                                    Enter Price.
                                </div>
                                <div *ngIf="mcxPriceName.errors?.pattern" class="invalid-error">
                                    Enter Valid Qty.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}" *ngIf="isBrokrageCheck">
                            <label for="Type" class="col-form-label">Type</label>
                            <select class="form-control" [(ngModel)]="filter.mcxBroType" name="mcxBrokrageType"
                                #mcxBrokrageType="ngModel"  [disabled]="endOrder==true">
                                <option [ngValue]="null">Brokrage Type</option>
                                <option value="lot">Lotwise</option>
                                <option value="per">Turnoverwise % | Lakh</option>
                            </select>
                            <!-- <div *ngIf="rollbackBadlaOrder.submitted">
                                <div *ngIf="mcxBrokrageType.errors?.required" class="invalid-error">
                                    Please Select Type.
                                </div>
                            </div> -->
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}" *ngIf="isBrokrageCheck">
                            <label for="Brokerage Amount" class="col-form-label">Brokerage Amount</label>
                            <input type="text" class="form-control" placeholder="Brokerage Amount"
                                [(ngModel)]="filter.mcxBroAmount" name="mcxBrokrageAmount" #mcxBrokrageAmount="ngModel"
                                 pattern="^[0-9._-]*$" maxlength="5" [disabled]="endOrder==true">
                            <div *ngIf="rollbackBadlaOrder.submitted">
                                <!-- <div *ngIf="mcxBrokrageAmount.errors?.required" class="invalid-error">
                                    Enter Amount.
                                </div> -->
                                <div *ngIf="mcxBrokrageAmount.errors?.pattern" class="invalid-error">
                                    Enter Valid Amount.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="inputPassword" class=" col-form-label">DGCX Instrument</label>
                            <input class="form-check-input chak-obox" type="checkbox" [(ngModel)]="isDgcxROCheck" name="dgcxCheckbox" (change)="checkRollover('dgcx',isDgcxROCheck?true:false)">

                            <select class="form-control" [(ngModel)]="filter.dgcxbadlaInst" name="dgcxInstName" (change)="chnageInsrument($event.target.value,'dgcxRateId')"
                                #dgcxInstName="ngModel" required disabled>
                                <option [ngValue]="null">Select Instrument</option>
                                <option *ngFor="let badla of dgcxBadlaInstrument" [value]="badla.instrument_token">
                                    {{badla.exchange}} - {{badla.name}} - {{badla.expiry}}
                                </option>
                            </select>
                            <div id="dgcxRateId"></div>
                            <div *ngIf="rollbackBadlaOrder.submitted">
                                <div *ngIf="dgcxInstName.errors?.required" class="invalid-error">
                                    Please Select DGCX Instrument.
                                </div>
                            </div>
                        </div>
                     
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Type" class=" col-form-label">Type</label>
                            <select class="form-control" [(ngModel)]="filter.dgcxType" name="dgcxTypeName"
                                #dgcxTypeName="ngModel" required disabled='true'>
                                <option [ngValue]="null">Type</option>
                                <option value="buy">Buy</option>
                                <option value="sell">Sell</option>
                            </select>
                            <div *ngIf="rollbackBadlaOrder.submitted">
                                <div *ngIf="dgcxTypeName.errors?.required" class="invalid-error">
                                    Please Select Type.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Qty" class=" col-form-label">Qty</label>
                            <input type="text" class="form-control" placeholder="Qty" [(ngModel)]="filter.dgcxQty"
                                name="dgcxQtyeName" #dgcxQtyeName="ngModel" required pattern="^[0-9.]*$"
                                disabled>
                            <div *ngIf="rollbackBadlaOrder.submitted">
                                <div *ngIf="dgcxQtyeName.errors?.required" class="invalid-error">
                                    Enter Qty.
                                </div>
                                <div *ngIf="dgcxQtyeName.errors?.pattern" class="invalid-error">
                                    Enter Valid Qty.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Price" class=" col-form-label">Price</label>
                            <input type="text" class="form-control" [(ngModel)]="filter.dgcxPrice" placeholder="Price"
                                name="dgcxPriceName" #dgcxPriceName="ngModel" required pattern="^[0-9_.-]*$">
                            <div *ngIf="rollbackBadlaOrder.submitted">
                                <div *ngIf="dgcxPriceName.errors?.required" class="invalid-error">
                                    Enter Price.
                                </div>
                                <div *ngIf="dgcxPriceName.errors?.pattern" class="invalid-error">
                                    Enter Valid Price.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}" *ngIf="isBrokrageCheck">
                            <label for="inputPassword" class=" col-form-label">Type</label>
                            <select class="form-control" [(ngModel)]="filter.dgcxBroType" name="dgcxBrokrageType"
                                #dgcxBrokrageType="ngModel" [disabled]="endOrder==true">
                                <option [ngValue]="null">Brokrage Type</option>
                                <option value="lot">Lotwise</option>
                                <!-- <option value="sell">Percentage</option> -->
                            </select>
                            <!-- <div *ngIf="rollbackBadlaOrder.submitted">
                                <div *ngIf="dgcxBrokrageType.errors?.required" class="invalid-error">
                                    Please Select Type.
                                </div>
                            </div> -->
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}" *ngIf="isBrokrageCheck">
                            <label for="Brokerage Amount" class=" col-form-label">Brokerage Amount</label>
                            <input type="text" class="form-control" placeholder="Brokerage Amount"
                                [(ngModel)]="filter.dgcxBroAmount" name="dgcxBrokrageAmount"
                                #dgcxBrokrageAmount="ngModel" pattern="^[0-9._-]*$" maxlength="5"
                                [disabled]="endOrder==true">
                            <div *ngIf="rollbackBadlaOrder.submitted">
                                <!-- <div *ngIf="dgcxBrokrageAmount.errors?.required" class="invalid-error">
                                    Enter Amount.
                                </div> -->
                                <div *ngIf="dgcxBrokrageAmount.errors?.pattern" class="invalid-error">
                                    Enter Valid Amount.
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="input-box-grup  d-flex ">
                        <h6>Rollover Instrument</h6>
                        <div class="form-check mx-3" *ngIf="endOrder == false">
                            <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault"
                                [(ngModel)]="isBrokrageROCheck" name="brokrageCheckBox" #brokrageCheckBox="ngModel"
                                (change)="checkBrokrageRO(isBrokrageROCheck?true:false)">
                            <label class="form-check-label" for="flexCheckDefault">
                                Rollover Brokerage 
                            </label>
                        </div>

                    </div>
 
                    <div class="form-group row" *ngIf="isComexROCheck == true">
                        <div class="{{isBrokrageROCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="inputPassword" class="col-form-label">COMEX Instrument</label>
                            <select class="form-control" [(ngModel)]="filter.comexRolloverbadlaInst" name="comexRolloverInstName"
                                #comexRolloverInstName="ngModel" (change)="chnageInsrument($event.target.value,'comexRateId')"  [disabled]="endOrder==true" required>
                                <option [ngValue]="null">Select Instrument</option>
                                <option *ngFor="let badla of comexBadlaInstrument" [value]="badla.instrument_token">
                                    {{badla.exchange}} - {{badla.name}} - {{badla.expiry}}
                                </option>
                            </select>
                            <div id="comexRateIdRollover"></div>
                            <div *ngIf="rollbackBadlaOrder.submitted">
                                <div *ngIf="comexRolloverInstName.errors?.required" class="invalid-error">
                                    Please Select COMEX Instrument.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageROCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Type" class="col-form-label">Type</label>
                            <select class="form-control" [(ngModel)]="filter.comexRolloverType" name="comexRolloverTypeName"
                                #comexRolloverTypeName="ngModel"  [disabled]="endOrder==true" disabled>
                                <option [ngValue]="null">Type</option>
                                <option value="buy">Buy</option>
                                <option value="sell">Sell</option>
                            </select>
                        </div>
                        <div class="{{isBrokrageROCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Qty" class="col-form-label">Qty</label>
                            <input type="text" class="form-control" placeholder="Qty" [(ngModel)]="filter.comexRolloverQty"
                                name="comexRolloverQtyeName" #comexRolloverQtyeName="ngModel"  pattern="^[0-9._-]*$"
                                maxlength="5" [disabled]="endOrder==true" required>
                            <div *ngIf="rollbackBadlaOrder.submitted">
                                <div *ngIf="comexRolloverQtyeName.errors?.pattern" class="invalid-error">
                                    Enter Valid Qty.
                                </div>
                                <div *ngIf="comexRolloverQtyeName.errors?.required" class="invalid-error">
                                    Enter Qty.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageROCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Price" class="col-form-label">Price</label>
                            <input type="text" class="form-control" [(ngModel)]="filter.comexRolloverPrice" placeholder="Price"
                                name="comexRolloverPriceName" #comexRolloverPriceName="ngModel" pattern="^[0-9.]*$"
                                maxlength="10" required>
                            <div *ngIf="rollbackBadlaOrder.submitted">
                                <div *ngIf="comexRolloverPriceName.errors?.pattern" class="invalid-error">
                                    Enter Valid Price.
                                </div>
                                <div *ngIf="comexRolloverPriceName.errors?.required" class="invalid-error">
                                    Enter Price.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageROCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}" *ngIf="isBrokrageROCheck">
                            <label for="Type" class="col-form-label">Type</label>
                            <select class="form-control" [(ngModel)]="filter.comexRolloverBroType" name="comexRolloverBrokrageType"
                                #comexRolloverBrokrageType="ngModel" [disabled]="endOrder==true">
                                <option [ngValue]="null">Brokrage Type</option>
                                <option value="lot">Lotwise</option>
                                <!-- <option value="sell">Percentage</option> -->
                            </select>
                            <div *ngIf="rollbackBadlaOrder.submitted">
                                <div *ngIf="comexRolloverBrokrageType.errors?.required" class="invalid-error">
                                    Please Select Type.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageROCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}" *ngIf="isBrokrageROCheck">
                            <label for="Brokerage Amount" class="col-form-label">Brokerage Amount</label>
                            <input type="text" class="form-control" placeholder="Brokerage Amount"
                                [(ngModel)]="filter.comexRolloverBroAmount" name="comexRolloverBrokrageAmount"
                                #comexRolloverBrokrageAmount="ngModel"  pattern="^[0-9._-]*$" maxlength="5"
                                [disabled]="endOrder==true">
                            <div *ngIf="rollbackBadlaOrder.submitted">
                                <div *ngIf="comexRolloverBrokrageAmount.errors?.pattern" class="invalid-error">
                                    Enter Valid Amount.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row" *ngIf="isMcxROCheck == true">
                        <div class="{{isBrokrageROCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="MCX Instrument" class="col-form-label">MCX Instrument</label>
                            <select class="form-control" [(ngModel)]="filter.mcxRolloverbadlaInst" name="mcxRolloverInstName" (change)="chnageInsrument($event.target.value,'mcxRateId')" 
                                #mcxRolloverInstName="ngModel" [disabled]="endOrder==true" required>
                                <option [ngValue]="null">Select Instrument</option>
                                <option *ngFor="let badla of mcxBadlaInstrument" [value]="badla.instrument_token">
                                    {{badla.exchange}} - {{badla.name}} - {{badla.expiry}}
                                </option>
                            </select>
                            <div id="mcxRateIdRollover"></div>
                            <div *ngIf="rollbackBadlaOrder.submitted">
                                <div *ngIf="mcxRolloverInstName.errors?.required" class="invalid-error">
                                    Enter Valid Amount.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageROCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Type" class="col-form-label">Type</label>
                            <select class="form-control" [(ngModel)]="filter.mcxRolloverType" name="mcxRolloverTypeName"
                                #mcxRolloverTypeName="ngModel" disabled>
                                <option [ngValue]="null">Type</option>
                                <option value="buy">Buy</option>
                                <option value="sell">Sell</option>
                            </select>
                        </div>
                        <div class="{{isBrokrageROCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Qty" class="col-form-label">Qty</label>
                            <input type="text" class="form-control" [(ngModel)]="filter.mcxRolloverQty" placeholder="Qty"
                                name="mcxRolloverQtyeName" #mcxRolloverQtyeName="ngModel" pattern="^[0-9.]*$"
                                [disabled]="endOrder==true" required>
                            <div *ngIf="rollbackBadlaOrder.submitted">
                                <div *ngIf="mcxRolloverQtyeName.errors?.pattern" class="invalid-error">
                                    Enter Valid Qty.
                                </div>
                                <div *ngIf="mcxRolloverQtyeName.errors?.required" class="invalid-error">
                                    Enter Qty.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageROCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Price" class="col-form-label">Price</label>
                            <input type="text" class="form-control" [(ngModel)]="filter.mcxRolloverPrice" placeholder="Price"
                                name="mcxRolloverPriceName" #mcxRolloverPriceName="ngModel" pattern="^[0-9_.-]*$" required>
                            <div *ngIf="rollbackBadlaOrder.submitted">
                                <div *ngIf="mcxRolloverPriceName.errors?.pattern" class="invalid-error">
                                    Enter Valid Qty.
                                </div>
                                <div *ngIf="mcxRolloverPriceName.errors?.required" class="invalid-error">
                                    Enter Price.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageROCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}" *ngIf="isBrokrageROCheck">
                            <label for="Type" class="col-form-label">Type</label>
                            <select class="form-control" [(ngModel)]="filter.mcxRolloverBroType" name="mcxRolloverBrokrageType"
                                #mcxRolloverBrokrageType="ngModel" [disabled]="endOrder==true">
                                <option [ngValue]="null">Brokrage Type</option>
                                <option value="lot">Lotwise</option>
                                <option value="per">Turnoverwise % | Lakh</option>
                            </select>
                        </div>
                        <div class="{{isBrokrageROCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}" *ngIf="isBrokrageROCheck">
                            <label for="Brokerage Amount" class="col-form-label">Brokerage Amount</label>
                            <input type="text" class="form-control" placeholder="Brokerage Amount"
                                [(ngModel)]="filter.mcxRolloverBroAmount" name="mcxRolloverBrokrageAmount" #mcxRolloverBrokrageAmount="ngModel"
                                 pattern="^[0-9._-]*$" maxlength="5" [disabled]="endOrder==true">
                            <div *ngIf="rollbackBadlaOrder.submitted">
                                <div *ngIf="mcxRolloverBrokrageAmount.errors?.pattern" class="invalid-error">
                                    Enter Valid Amount.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row" *ngIf="isDgcxROCheck == true">
                        <div class="{{isBrokrageROCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="inputPassword" class=" col-form-label">DGCX Instrument</label>
                            <select class="form-control" [(ngModel)]="filter.dgcxRolloverbadlaInst" name="dgcxRolloverInstName" (change)="chnageInsrument($event.target.value,'dgcxRateId')"
                                #dgcxRolloverInstName="ngModel" [disabled]="endOrder==true" required>
                                <option [ngValue]="null">Select Instrument</option>
                                <option *ngFor="let badla of dgcxBadlaInstrument" [value]="badla.instrument_token">
                                    {{badla.exchange}} - {{badla.name}} - {{badla.expiry}}
                                </option>
                            </select>
                            <div id="dgcxRateIdRollover"></div>
                            <div *ngIf="rollbackBadlaOrder.submitted">
                                <div *ngIf="dgcxRolloverInstName.errors?.required" class="invalid-error">
                                    Select Instrument
                                </div>
                            </div>
                        </div>
                     
                        <div class="{{isBrokrageROCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Type" class=" col-form-label">Type</label>
                            <select class="form-control" [(ngModel)]="filter.dgcxRolloverType" name="dgcxRolloverTypeName"
                                #dgcxRolloverTypeName="ngModel" disabled>
                                <option [ngValue]="null">Type</option>
                                <option value="buy">Buy</option>
                                <option value="sell">Sell</option>
                            </select>
                        </div>
                        <div class="{{isBrokrageROCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Qty" class=" col-form-label">Qty</label>
                            <input type="text" class="form-control" placeholder="Qty" [(ngModel)]="filter.dgcxRolloverQty"
                                name="dgcxRolloverQtyeName" #dgcxRolloverQtyeName="ngModel"  pattern="^[0-9.]*$"
                                [disabled]="endOrder==true" required>
                            <div *ngIf="rollbackBadlaOrder.submitted">
                                <div *ngIf="dgcxRolloverQtyeName.errors?.pattern" class="invalid-error">
                                    Enter Valid Qty.
                                </div>
                                <div *ngIf="dgcxRolloverQtyeName.errors?.required" class="invalid-error">
                                    Enter Valid Qty.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageROCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Price" class=" col-form-label">Price</label>
                            <input type="text" class="form-control" [(ngModel)]="filter.dgcxRolloverPrice" placeholder="Price"
                                name="dgcxRolloverPriceName" #dgcxRolloverPriceName="ngModel"  pattern="^[0-9_.-]*$" required>
                            <div *ngIf="rollbackBadlaOrder.submitted">
                                <div *ngIf="dgcxRolloverPriceName.errors?.pattern" class="invalid-error">
                                    Enter Valid Price.
                                </div>
                                <div *ngIf="dgcxRolloverPriceName.errors?.required" class="invalid-error">
                                    Enter Price.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageROCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}" *ngIf="isBrokrageROCheck">
                            <label for="inputPassword" class=" col-form-label">Type</label>
                            <select class="form-control" [(ngModel)]="filter.dgcxRolloverBroType" name="dgcxRolloverBrokrageType"
                                #dgcxRolloverBrokrageType="ngModel"  [disabled]="endOrder==true">
                                <option [ngValue]="null">Brokrage Type</option>
                                <option value="lot">Lotwise</option>
                                <!-- <option value="sell">Percentage</option> -->
                            </select>
                        </div>
                        <div class="{{isBrokrageROCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}" *ngIf="isBrokrageROCheck">
                            <label for="Brokerage Amount" class=" col-form-label">Brokerage Amount</label>
                            <input type="text" class="form-control" placeholder="Brokerage Amount"
                                [(ngModel)]="filter.dgcxRolloverBroAmount" name="dgcxRolloverBrokrageAmount"
                                #dgcxRolloverBrokrageAmount="ngModel"  pattern="^[0-9._-]*$" maxlength="5"
                                [disabled]="endOrder==true" required>
                            <div *ngIf="rollbackBadlaOrder.submitted">
                                <div *ngIf="dgcxRolloverBrokrageAmount.errors?.pattern" class="invalid-error">
                                    Enter Valid Amount.
                                </div>
                                <div *ngIf="dgcxRolloverBrokrageAmount.errors?.required" class="invalid-error">
                                    Enter Valid Amount.
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row mt-2">
                        <div class="col-6 m-0 ">
                            <button type="button" class="btn btn-danger w-100" data-dismiss="modal"
                                (click)="closeRolloverBadlaOrder()">Close</button>
                        </div>

                        <div class="col-6 m-0 " >
                            <button type="submit" class="btn btn-success w-100">Submit</button>
                        </div>
                    </div>
                    <!--  -->
                </form>
            </div>
        </div>
    </div>
</div>


<div class="modal fade" bsModal #settleModal="bs-modal" [config]="{}" id="exampleModalCenter" tabindex="-1"
    role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h6 class="modal-title" id="exampleModalLongTitle"><span>Settled badla order</span></h6>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="closeSettledModal()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form #settledForm="ngForm" (ngSubmit)="(settledForm.form.valid  && settledBadlaOrder())">
                    <div class="form-group row" *ngFor="let orderInst of orderInstruments; let index = index;">
                        <label for="inputPassword" class="col-sm-6 col-form-label">{{orderInst['original_exchange']}}
                            {{orderInst['name']}} {{orderInst['expiry']}}</label>
                        <div class="col-sm-12 p-0 m-0">
                            <input type="text" class="form-control" placeholder="Price" name="setInstrument{{ index }}"
                                #setInstrument="ngModel" [(ngModel)]="settledIns[orderInst['instrument_token']]"
                                pattern="^[0-9_.-]*$">
                            <div *ngIf="settledForm.submitted">
                                <!-- <div *ngIf="setInstrument.errors?.required" class="invalid-error">
                                  Enter {{orderInst['original_exchange']}} {{orderInst['name']}}  Price.
                                </div> -->
                                <div *ngIf="setInstrument.errors?.pattern" class="invalid-error">
                                    Enter Valid Price.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" *ngIf="orderInstruments.length == 0">
                        <div class="col-sm-12">
                            <div class="invalid-error">
                                No Instrument Found.
                            </div>    
                        </div>
                    </div>
                    <br>
                    <div class="form-group row">
                        <label for="inputPassword" class="col-sm-6 col-form-label">Settled Clearing Rate ? </label>
                        <input class="form-check-input clearingCheck" type="checkbox" value="" id="flexCheckDefault"
                        [(ngModel)]="dollerClCheck" name="dollerCheckBox" #brokrageCheckBox="ngModel"
                        (change)="clearingRate(dollerClCheck?true:false)">
                    </div>

                    <div class="form-group row" *ngIf="dollerClCheck == true">
                        <!-- <label for="inputPassword" class="col-sm-6 col-form-label">Doller Closing Rate</label> -->
                        <div class="col-sm-12 p-0 m-0">
                            <input type="text" class="form-control" placeholder="Clearing Doller Rate" name="closingRate"
                                #closingRateAmt="ngModel" [(ngModel)]="closingRate"
                                pattern="^[0-9_.-]*$">
                            <div *ngIf="settledForm.submitted">
                                <div *ngIf="closingRateAmt.errors?.pattern" class="invalid-error">
                                    Enter Valid Price.
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row" *ngIf="orderInstruments.length > 0">
                        <div class="col-6 m-0 p-2">
                            <button type="button" class="btn btn-danger w-100" data-dismiss="modal"
                            (click)="closeSettledModal()">Close</button>
                        </div>
                        <div class="col-6 m-0 p-2">
                            <button type="submit" class="btn btn-success w-100">Submit</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>


<div class="modal fade" bsModal #deleteModal="bs-modal" [config]="{}" id="exampleModalCenter" tabindex="-1"
    role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h6 class="modal-title" id="exampleModalLongTitle"><span>Delete badla order</span></h6>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="closeDeleteBadlaOrder()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p>Are you sure you want to delete?</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-danger" (click)="closeDeleteBadlaOrder()">Close</button>
                <button type="button" class="btn btn-success" (click)="deleteBadlaOrder()">Confirm</button>
            </div>
        </div>
    </div>
</div>


<div class="modal fade" bsModal #openingModal="bs-modal" [config]="{}" id="exampleModalCenter" tabindex="-1"
    role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h6 class="modal-title" id="exampleModalLongTitle"><span>Edit Opening</span></h6>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="closeOpeningModal()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form #openingForm="ngForm" (ngSubmit)="(openingForm.form.valid  && openingSubmit())">
                    <div class="form-group row">
                        <label for="inputPassword" class="col-sm-6 col-form-label">Opening Amount</label>
                        <div class="col-sm-12 p-0 m-0">
                            <input type="text" class="form-control" placeholder="Opening" name="openingAmt"
                                #openingAmt="ngModel" [(ngModel)]="openingAmountModal" required
                                pattern="^[0-9_.-]*$">
                            <div *ngIf="openingForm.submitted">
                                <div *ngIf="openingAmt.errors?.required" class="invalid-error">
                                    Enter Amount.
                                </div>
                                <div *ngIf="openingAmt.errors?.pattern" class="invalid-error">
                                    Enter Valid Opening.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6 m-0 p-2">
                            <button type="button" class="btn btn-danger w-100" data-dismiss="modal"
                            (click)="closeOpeningModal()">Close</button>
                        </div>
                        <div class="col-6 m-0 p-2">
                            <button type="submit" class="btn btn-success w-100">Submit</button>
                        </div>
                    </div>
                </form>
    
            </div>
        </div>
    </div>
</div>

<div class="modal fade" bsModal #dollerModal="bs-modal" [config]="{}" id="exampleModalCenter" tabindex="-1"
    role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h6 class="modal-title" id="exampleModalLongTitle"><span>Doller Price</span></h6>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="closeDollerModal()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form #dollerForm="ngForm" (ngSubmit)="(dollerForm.form.valid  && dollerSubmit())">
                    <div class="form-group row">
                        <div class="row">
                            <div  [ngClass]="customeDollerCheck ? 'col-sm-6 p-0 m-0 Position-' : 'col-sm-12 p-0 m-0 Position-'">
                                <!-- <input type="text" class="form-control" placeholder="Doller Price" name="dollerAmt"
                                    #dollerAmt="ngModel" [(ngModel)]="dollerAmountModal" required
                                    pattern="^[0-9_.-]*$"> -->
                                    <input class=" position-relative mx-2" type="checkbox" id="exampleSwitch" name="dollercheck"
                                    #dollercheck="ngModel" [(ngModel)]="customeDollerCheck">
                                    <label class="form-check-label" for="exampleSwitch" class="ml2">Custome Doller Rate </label>
                                    
                            </div>
                            <div class="col-sm-6 p-0 m-0" *ngIf="customeDollerCheck">
                                <input type="text" class="form-control" placeholder="Doller Price" name="dollerAmt"
                                    #dollerAmt="ngModel" [(ngModel)]="dollerAmountModal" required
                                    pattern="^[0-9_.-]*$">
                                <div *ngIf="dollerForm.submitted">
                                    <div *ngIf="dollerAmt.errors?.required" class="invalid-error">
                                        Enter Doller Amount.
                                    </div>
                                    <div *ngIf="dollerAmt.errors?.pattern" class="invalid-error">
                                        Enter Valid doller.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6 m-0 p-2">
                            <button type="button" class="btn btn-danger w-100" data-dismiss="modal"
                            (click)="closeDollerModal()">Close</button>
                        </div>
                        <div class="col-6 m-0 p-2">
                            <button type="submit" class="btn btn-success w-100">Submit</button>
                        </div>
                    </div>
                </form>
    
            </div>
        </div>
    </div>
</div>

<div class="modal fade" bsModal #editDifferenceModal="bs-modal" [config]="{}" id="exampleModalCenter" tabindex="-1"
    role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h6 class="modal-title" id="exampleModalLongTitle"><span>Edit Difference</span></h6>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="closeEditDifferenceModal()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form #differenceForm="ngForm" (ngSubmit)="(differenceForm.form.valid  && differenceSubmit())">
                    <div class="form-group row">
                        <label for="inputPassword" class="col-sm-6 col-form-label">Comex Difference</label>
                        <div class="col-sm-12 p-0 m-0">
                            <input type="text" class="form-control" placeholder="Comex Difference" name="comexDiffAmt"
                                #comexDiffAmt="ngModel" [(ngModel)]="diffObject.comexDiffAmt" required
                                pattern="^[0-9_.-]*$">
                            <div *ngIf="differenceForm.submitted">
                                <div *ngIf="comexDiffAmt.errors?.required" class="invalid-error">
                                    Enter Amount.
                                </div>
                                <div *ngIf="comexDiffAmt.errors?.pattern" class="invalid-error">
                                    Enter Valid Opening.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="inputPassword" class="col-sm-6 col-form-label">MCX Difference</label>
                        <div class="col-sm-12 p-0 m-0">
                            <input type="text" class="form-control" placeholder="Comex Difference" name="mcxDiffAmt"
                                #mcxDiffAmt="ngModel" [(ngModel)]="diffObject.mcxDiffAmt" required
                                pattern="^[0-9_.-]*$">
                            <div *ngIf="differenceForm.submitted">
                                <div *ngIf="mcxDiffAmt.errors?.required" class="invalid-error">
                                    Enter Amount.
                                </div>
                                <div *ngIf="mcxDiffAmt.errors?.pattern" class="invalid-error">
                                    Enter Valid Opening.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="inputPassword" class="col-sm-6 col-form-label">DGCX Difference</label>
                        <div class="col-sm-12 p-0 m-0">
                            <input type="text" class="form-control" placeholder="DGCX Difference" name="dgcxDiffAmt"
                                #dgcxDiffAmt="ngModel" [(ngModel)]="diffObject.dgcxDiffAmt" required
                                pattern="^[0-9_.-]*$">
                            <div *ngIf="differenceForm.submitted">
                                <div *ngIf="dgcxDiffAmt.errors?.required" class="invalid-error">
                                    Enter Amount.
                                </div>
                                <div *ngIf="dgcxDiffAmt.errors?.pattern" class="invalid-error">
                                    Enter Valid Opening.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6 m-0 p-2">
                            <button type="button" class="btn btn-danger w-100" data-dismiss="modal"
                            (click)="closeEditDifferenceModal()">Close</button>
                        </div>
                        <div class="col-6 m-0 p-2">
                            <button type="submit" class="btn btn-success w-100">Submit</button>
                        </div>
                    </div>
                </form>
    
            </div>
        </div>
    </div>
</div>


<div class="modal fade" bsModal #avgModal="bs-modal" [config]="{}" id="exampleModalCenter" tabindex="-1"
    role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h6 class="modal-title" id="exampleModalLongTitle"><span>Average badla order</span></h6>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="closeAvgModal()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <table class="default-table-style badla-tebal-box">
                    <thead>
                        <th>Instrument</th>
                        <th>Buy Average</th>
                        <th>Sell Average</th>
                        <th>Total Average</th>
                    </thead>
                    <tbody>
                        <tr>
                            <td>COMEX</td>
                            <td>{{(buyAvg)?(buyAvg['avgComex'] | number:'1.2-2'):0}}</td>
                            <td>{{(sellAvg)?(sellAvg['avgComex'] | number:'1.2-2'):0}}</td>
                            <td>{{(totalAvg)?(totalAvg['avgComex'] | number:'1.2-2'):0}}</td>
                        </tr>
                        <tr>
                            <td>MCX</td>
                            <td>{{(buyAvg)?(buyAvg['avgMcx'] | number:'1.2-2'):0}}</td>
                            <td>{{(sellAvg)?(sellAvg['avgMcx'] | number:'1.2-2'):0}}</td>
                            <td>{{(totalAvg)?(totalAvg['avgMcx'] | number:'1.2-2'):0}}</td>
                        </tr>
                        <tr>
                            <td>DGCX</td>
                            <td>{{(buyAvg)?(buyAvg['avgDgcx'] | number:'1.2-2'):0}}</td>
                            <td>{{(sellAvg)?(sellAvg['avgDgcx'] | number:'1.2-2'):0}}</td>
                            <td>{{(totalAvg)?(totalAvg['avgDgcx'] | number:'1.2-2'):0}}</td>
                        </tr>
                        <tr>
                            <td>BADLA AVG</td>
                            <td>{{(buyAvg)?(buyAvg['avgBadla'] | number:'1.2-2'):0}}</td>
                            <td>{{(sellAvg)?(sellAvg['avgBadla'] | number:'1.2-2'):0}}</td>
                            <td>{{(totalAvg)?(totalAvg['avgBadla'] | number:'1.2-2'):0}}</td>
                        </tr>

                    </tbody>
                </table>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-danger" (click)="closeAvgModal()">Close</button>
            </div>
        </div>
    </div>
</div>


<div class="modal fade" bsModal #partialOrderModal="bs-modal" [config]="{}" id="exampleModalCenter" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg " role="document">
        <div class="modal-content ">
            <div class="modal-header">
                <h6 class="modal-title" id="exampleModalLongTitle"><span>Badla Order partial</span></h6>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModalPartialOrder()">
                    <span aria-hidden="true">&times;</span>
                </button>

            </div>
            <div class="modal-body p-0 m-2">
                <form #addBadlaOrder="ngForm" (ngSubmit)="(addBadlaOrder.form.valid  && partialOrderSubmit())">
                    <div class="form-group row">
                        <div class=" col-lg-4 col-sm-6 col-6 input-box-grup">
                            <label for="inputPassword" class=" col-form-label">Reference Name</label>
                            <input type="text" class="form-control" placeholder="Reference Name"
                                [(ngModel)]="filter.reference" name="referenceName" #referenceName="ngModel" required disabled
                                pattern="^[A-Za-z0-9._ -]*$" maxlength="50">
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="referenceName.errors?.required" class="invalid-error">
                                    Enter Reference.
                                </div>
                                <div *ngIf="referenceName.errors?.pattern" class="invalid-error">
                                    Enter Valid Reference.
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-sm-6 col-6 input-box-grup" *ngIf="!filter.id && endOrder==false">
                            <label for="inputPassword" class="col-form-label ">Select Badla Type</label>
                            <select class="form-control" name="badlaType" (change)="badlaTypeChnage($event.target.value)" [(ngModel)]="selectedBadlaType">
                                <option [ngValue]="null">All</option>
                                <option *ngFor="let category of instrumentCategory; let i = index;" value="{{category.name}}">{{category.name}}</option>                          
                            </select>
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="badlaType.errors?.required" class="invalid-error">
                                    Please Select Badla Type.
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-2 col-sm-3 col-6 input-box-grup main-chek " >
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault"
                                    [(ngModel)]="isBrokrageCheck" name="brokrageCheckBox" #brokrageCheckBox="ngModel"
                                    (change)="checkBrokrage(isBrokrageCheck?true:false)" *ngIf="endOrder == false" >
                                <label class="form-check-label" for="flexCheckDefault">
                                    Add Brokerage
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-lg-4 col-sm-6 col-6 input-box-grup">
                            <label for="inputPassword" class="col-form-label ">Badla Instrument</label>
                            <select class="form-control" [(ngModel)]="filter.type" name="badlaType" #badlaType="ngModel"
                                required disabled (change)="badlaScriptChnage($event.target.value)">
                                <option [ngValue]="null" *ngIf="!filter.id && endOrder==false">Select Badla</option>
                                <option *ngFor="let title of badlaInstrument" [value]="title._id">
                                    {{title.settingName}}
                                </option>
                            </select>
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="badlaType.errors?.required" class="invalid-error">
                                    Please Select Badla Type.
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 col-sm-6 col-6 input-box-grup">
                            <label for="inputPassword" class="col-sm-2 col-form-label">Duty</label>
                            <input type="text" class="form-control" placeholder="Duty" [(ngModel)]="filter.duty"
                                name="dutyName" #dutyName="ngModel" required pattern="^[0-9._-]*$" maxlength="10"
                                disabled>
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="dutyName.errors?.required" class="invalid-error">
                                    Enter Duty.
                                </div>
                                <div *ngIf="dutyName.errors?.pattern" class="invalid-error">
                                    Enter Valid Duty.
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-sm-6 col-6 input-box-grup"  *ngIf="!filter.id && endOrder==false">
                            <label for="inputPassword" >Opening Amount(Optional)</label>
                            <input type="text" class="form-control" placeholder="Opening Amount" [(ngModel)]="filter.openingAmount"
                                name="openingAmount" #openingAmount="ngModel" pattern="^[0-9._-]*$" maxlength="10"
                                disabled>
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="openingAmount.errors?.pattern" class="invalid-error">
                                    Enter Valid Opening Amount.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="inputPassword" class="col-form-label">COMEX Instrument</label>
                            <select class="form-control" [(ngModel)]="filter.comexbadlaInst" name="comexInstName"
                                #comexInstName="ngModel" (change)="chnageInsrument($event.target.value,'comexRateId')" required disabled>
                                <option [ngValue]="null">Select Instrument</option>
                                <option *ngFor="let badla of comexBadlaInstrument" [value]="badla.instrument_token">
                                    {{badla.exchange}} - {{badla.name}} - {{badla.expiry}}
                                </option>
                            </select>
                            <div id="comexRateId"></div>
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="comexInstName.errors?.required" class="invalid-error">
                                    Please Select COMEX Instrument.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Type" class="col-form-label">Type</label>
                            <select class="form-control" [(ngModel)]="filter.comexType" name="comexTypeName"
                                #comexTypeName="ngModel" required (change)="comexTypeChnage()"
                                disabled>
                                <option [ngValue]="null">Type</option>
                                <option value="buy">Buy</option>
                                <option value="sell">Sell</option>
                            </select>
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="comexTypeName.errors?.required" class="invalid-error">
                                    Please Select Type.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Qty" class="col-form-label">Qty</label>
                            <input type="text" class="form-control" placeholder="Qty" [(ngModel)]="filter.comexQty"
                                name="comexQtyeName" #comexQtyeName="ngModel" required pattern="^[0-9._-]*$"
                                maxlength="5">
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="comexQtyeName.errors?.required" class="invalid-error">
                                    Enter Qty.
                                </div>
                                <div *ngIf="comexQtyeName.errors?.pattern" class="invalid-error">
                                    Enter Valid Qty.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Price" class="col-form-label">Price</label>
                            <input type="text" class="form-control" [(ngModel)]="filter.comexPrice" placeholder="Price"
                                name="comexPriceName" #comexPriceName="ngModel" required pattern="^[0-9.]*$"
                                maxlength="10">
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="comexPriceName.errors?.required" class="invalid-error">
                                    Enter Price.
                                </div>
                                <div *ngIf="comexPriceName.errors?.pattern" class="invalid-error">
                                    Enter Valid Price.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}" *ngIf="isBrokrageCheck">
                            <label for="Type" class="col-form-label">Type</label>
                            <select class="form-control" [(ngModel)]="filter.comexBroType" name="comexBrokrageType"
                                #comexBrokrageType="ngModel">
                                <option [ngValue]="null">Brokrage Type</option>
                                <option value="lot">Lotwise</option>
                                <!-- <option value="sell">Percentage</option> -->
                            </select>
                            <!-- <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="comexBrokrageType.errors?.required" class="invalid-error">
                                    Please Select Type.
                                </div>
                            </div> -->
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}" *ngIf="isBrokrageCheck">
                            <label for="Brokerage Amount" class="col-form-label">Brokerage Amount</label>
                            <input type="text" class="form-control" placeholder="Brokerage Amount"
                                [(ngModel)]="filter.comexBroAmount" name="comexBrokrageAmount"
                                #comexBrokrageAmount="ngModel" pattern="^[0-9._-]*$" maxlength="5">
                            <div *ngIf="addBadlaOrder.submitted">
                                <!-- <div *ngIf="comexBrokrageAmount.errors?.required" class="invalid-error">
                                    Enter Amount.
                                </div> -->
                                <div *ngIf="comexBrokrageAmount.errors?.pattern" class="invalid-error">
                                    Enter Valid Amount.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="MCX Instrument" class="col-form-label">MCX Instrument</label>
                            <select class="form-control" [(ngModel)]="filter.mcxbadlaInst" name="mcxInstName" (change)="chnageInsrument($event.target.value,'mcxRateId')" 
                                #mcxInstName="ngModel" required disabled>
                                <option [ngValue]="null">Select Instrument</option>
                                <option *ngFor="let badla of mcxBadlaInstrument" [value]="badla.instrument_token">
                                    {{badla.exchange}} - {{badla.name}} - {{badla.expiry}}
                                </option>
                            </select>
                            <div id="mcxRateId"></div>
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="mcxInstName.errors?.required" class="invalid-error">
                                    Please Select MCX Instrument.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Type" class="col-form-label">Type</label>
                            <select class="form-control" [(ngModel)]="filter.mcxType" name="mcxTypeName"
                                #mcxTypeName="ngModel" required disabled>
                                <option [ngValue]="null">Type</option>
                                <option value="buy">Buy</option>
                                <option value="sell">Sell</option>
                            </select>
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="mcxTypeName.errors?.required" class="invalid-error">
                                    Please Select Type.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Qty" class="col-form-label">Qty</label>
                            <input type="text" class="form-control" [(ngModel)]="filter.mcxQty" placeholder="Qty"
                                name="mcxQtyeName" #mcxQtyeName="ngModel" required pattern="^[0-9.]*$"
                                [disabled]="endOrder==true">
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="mcxQtyeName.errors?.required" class="invalid-error">
                                    Enter Qty.
                                </div>
                                <div *ngIf="mcxQtyeName.errors?.pattern" class="invalid-error">
                                    Enter Valid Qty.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Price" class="col-form-label">Price</label>
                            <input type="text" class="form-control" [(ngModel)]="filter.mcxPrice" placeholder="Price"
                                name="mcxPriceName" #mcxPriceName="ngModel" pattern="^[0-9_.-]*$" required>
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="mcxPriceName.errors?.required" class="invalid-error">
                                    Enter Price.
                                </div>
                                <div *ngIf="mcxPriceName.errors?.pattern" class="invalid-error">
                                    Enter Valid Qty.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}" *ngIf="isBrokrageCheck">
                            <label for="Type" class="col-form-label">Type</label>
                            <select class="form-control" [(ngModel)]="filter.mcxBroType" name="mcxBrokrageType"
                                #mcxBrokrageType="ngModel">
                                <option [ngValue]="null">Brokrage Type</option>
                                <option value="lot">Lotwise</option>
                                <option value="per">Turnoverwise % | Lakh</option>
                            </select>
                            <!-- <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="mcxBrokrageType.errors?.required" class="invalid-error">
                                    Please Select Type.
                                </div>
                            </div> -->
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}" *ngIf="isBrokrageCheck">
                            <label for="Brokerage Amount" class="col-form-label">Brokerage Amount</label>
                            <input type="text" class="form-control" placeholder="Brokerage Amount"
                                [(ngModel)]="filter.mcxBroAmount" name="mcxBrokrageAmount" #mcxBrokrageAmount="ngModel"
                                 pattern="^[0-9._-]*$" maxlength="5">
                            <div *ngIf="addBadlaOrder.submitted">
                                <!-- <div *ngIf="mcxBrokrageAmount.errors?.required" class="invalid-error">
                                    Enter Amount.
                                </div> -->
                                <div *ngIf="mcxBrokrageAmount.errors?.pattern" class="invalid-error">
                                    Enter Valid Amount.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="inputPassword" class=" col-form-label">DGCX Instrument</label>
                            <select class="form-control" [(ngModel)]="filter.dgcxbadlaInst" name="dgcxInstName" (change)="chnageInsrument($event.target.value,'dgcxRateId')"
                                #dgcxInstName="ngModel" required disabled>
                                <option [ngValue]="null">Select Instrument</option>
                                <option *ngFor="let badla of dgcxBadlaInstrument" [value]="badla.instrument_token">
                                    {{badla.exchange}} - {{badla.name}} - {{badla.expiry}}
                                </option>
                            </select>
                            <div id="dgcxRateId"></div>
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="dgcxInstName.errors?.required" class="invalid-error">
                                    Please Select DGCX Instrument.
                                </div>
                            </div>
                        </div>
                     
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Type" class=" col-form-label">Type</label>
                            <select class="form-control" [(ngModel)]="filter.dgcxType" name="dgcxTypeName"
                                #dgcxTypeName="ngModel" required disabled>
                                <option [ngValue]="null">Type</option>
                                <option value="buy">Buy</option>
                                <option value="sell">Sell</option>
                            </select>
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="dgcxTypeName.errors?.required" class="invalid-error">
                                    Please Select Type.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Qty" class=" col-form-label">Qty</label>
                            <input type="text" class="form-control" placeholder="Qty" [(ngModel)]="filter.dgcxQty"
                                name="dgcxQtyeName" #dgcxQtyeName="ngModel" required pattern="^[0-9.]*$"
                                >
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="dgcxQtyeName.errors?.required" class="invalid-error">
                                    Enter Qty.
                                </div>
                                <div *ngIf="dgcxQtyeName.errors?.pattern" class="invalid-error">
                                    Enter Valid Qty.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Price" class=" col-form-label">Price</label>
                            <input type="text" class="form-control" [(ngModel)]="filter.dgcxPrice" placeholder="Price"
                                name="dgcxPriceName" #dgcxPriceName="ngModel" required pattern="^[0-9_.-]*$">
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="dgcxPriceName.errors?.required" class="invalid-error">
                                    Enter Price.
                                </div>
                                <div *ngIf="dgcxPriceName.errors?.pattern" class="invalid-error">
                                    Enter Valid Price.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}" *ngIf="isBrokrageCheck">
                            <label for="inputPassword" class=" col-form-label">Type</label>
                            <select class="form-control" [(ngModel)]="filter.dgcxBroType" name="dgcxBrokrageType"
                                #dgcxBrokrageType="ngModel">
                                <option [ngValue]="null">Brokrage Type</option>
                                <option value="lot">Lotwise</option>
                                <!-- <option value="sell">Percentage</option> -->
                            </select>
                            <!-- <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="dgcxBrokrageType.errors?.required" class="invalid-error">
                                    Please Select Type.
                                </div>
                            </div> -->
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}" *ngIf="isBrokrageCheck">
                            <label for="Brokerage Amount" class=" col-form-label">Brokerage Amount</label>
                            <input type="text" class="form-control" placeholder="Brokerage Amount"
                                [(ngModel)]="filter.dgcxBroAmount" name="dgcxBrokrageAmount"
                                #dgcxBrokrageAmount="ngModel" pattern="^[0-9._-]*$" maxlength="5">
                            <div *ngIf="addBadlaOrder.submitted"> 
                                <!-- <div *ngIf="dgcxBrokrageAmount.errors?.required" class="invalid-error">
                                    Enter Amount.
                                </div> -->
                                <div *ngIf="dgcxBrokrageAmount.errors?.pattern" class="invalid-error">
                                    Enter Valid Amount.
                                </div>
                            </div>
                        </div>
                    </div>

                                        <div class="form-group row">
                        <div class="col-lg-3 col-sm-6 col-6 input-box-grup">
                            <label for="Brokerage Amount" class=" col-form-label">Select End Badla Option</label>
                            <select class="form-control" [(ngModel)]="filter.endandopen" name="endBadlaType"
                                    #endBadlaType="ngModel" required  (change)="settlementTypeChnage($event.target.value)">
                                    <option [ngValue]="null">Type</option>
                                    <option value="3">Clearing Rate</option>
                            </select>
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="endBadlaType.errors?.required" class="invalid-error">
                                    Enter Badla Type.
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 col-sm-6 col-6 input-box-grup" *ngIf="(settlementType == '3') ">
                            <label for="Brokerage Amount" class=" col-form-label">Doller Closing Rate</label>
                            <input type="text" class="form-control" [(ngModel)]="closingRate" placeholder="Doller Closing"
                            name="closingRateAmt" #closingRateAmt="ngModel" required pattern="^[0-9_.-]*$">
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="closingRateAmt.errors?.required" class="invalid-error">
                                    Enter Doller Closing.
                                </div>
                            </div>
                        </div>

                    </div>


                    <div class="row mt-2">
                        <div class="col-6 m-0 ">
                            <button type="button" class="btn btn-danger w-100" data-dismiss="modal"
                                (click)="closeModalPartialOrder()">Close</button>
                        </div>

                        <div class="col-6 m-0 ">
                            <button type="submit" class="btn btn-success w-100">Submit</button>
                        </div>
                    </div>
                    <!--  -->
                </form>
            </div>
        </div>
    </div>
</div>


<div class="modal fade" bsModal #badDetailsRateModal="bs-modal" [config]="{}" id="exampleModalCenter" tabindex="-1"
    role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h6 class="modal-title" id="exampleModalLongTitle"><span>Doller Price</span></h6>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="closebadDetailsRateModal()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                    <div class="form-group row">
                        <div class="row">
                            <div  class="col-sm-12 p-0 m-0 Position-">
                                    <label class="form-check-label" for="exampleSwitch" class="ml2">Custome Doller Rate </label>
                            </div>
                        </div>
                    </div>    
            </div>
        </div>
    </div>
</div>
